import { Model } from '../model';
import { Paginated } from '../paginated';

export class SharingInfo extends Model {
  idSharing: number;
  idParentSharing: number;
  idUserSharing: number;
  idUserResourceOwner: number;
  idSubaccountProfile: number;
}

export class SharingTemplate extends Model {
  encoding: string;
  idPage: number | null;
  idTemplate: number;
  name: string;
  richUrl: string;
  sender: string;
  sharingInfo: SharingInfo;
  idParentSharing: number;
  idSharing: number;
  idSubaccountProfile: number;
  idUserResourceOwner: number;
  idUserSharing: number;
  text: string;
}

export class SharedBlacklist extends Model {
  userOwnerId: number;
  sharingInfo: SharingInfo;
}

export class ResellerProfile extends Model {
  idSubaccountProfile: number;
  name: string;
  enabledServices: Array<string>;
  enabledSMSQualities: Array<string>;
  isDefault: boolean;
  numSubaccount: number;
  sharedGroups: Array<string>;
  sharedBlacklists: Array<SharedBlacklist>;
  sharedTemplates: Array<SharingTemplate>;
}

export class ResellerProfiles extends Paginated {
  data: Array<ResellerProfile>;
}
